import PropTypes from 'prop-types';
import { useDocument } from 'react-firebase-hooks/firestore';
import { Box, Button, Card, CardActions, CardContent, CardMedia, IconButton, Skeleton, Typography } from '@mui/material';
import UserService from '../../services/user.service';
import Iconify from '../../components/iconify';
import { personprops } from '../../constants';

ViewUser.propTypes = {
  userId: PropTypes.string,
    setEditing: PropTypes.func,
    liff: PropTypes.object,
    setUser: PropTypes.func,
    toEdit: PropTypes.bool,
    userInitiated: PropTypes.bool
  };

export default function ViewUser(props) {
    const { liff, userId, setUser, setEditing, toEdit, userInitiated } = props

    // console.log('profile', profile);

    const [user, loadingUser, errorGetUser] = useDocument((!toEdit && !userInitiated)? UserService.user(userId) :  UserService.user(userId))

    // mappeduser

    if (errorGetUser) {
      return (<>no user found</>)}
    if (user) {
        setUser(u => ({...user.data(), ...u}))
        return (
          <div>
            {user.exists()
              ? (() => (
                  <Box>
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        backgroundColor: "#555",
                        m: 2,
                        mt: { xs: 2, sm: 8 },
                      }}
                    >
                      <CardMedia
                        sx={{
                          height: "50vh",
                          width: {
                            xs: "100%",
                            sm: "50%",
                            md: "30%",
                            lg: "20%",
                          },
                        }}
                        image={user.data().pictureUrl}
                        title={user.data().displayName}
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h4" component="div">
                          {[
                            ["rank", "name"]
                              .map((key) => user.data()[key])
                              .join(""),
                            user.data().surname,
                          ].join(" ")}
                        </Typography>
                        <Typography variant="h5" color="text.secondary">
                          {user.data().displayName}
                        </Typography>
                        <>
                          {["type", "unit", "position", "tel"]
                            .filter((name) => {
                              const prop = personprops[name];
                              return prop;
                            })
                            .map((name) => {
                              const prop = personprops[name];
                              console.log("prop", prop);
                              return (
                                <Typography
                                  key={name}
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {prop.label} :{" "}
                                  {user.data()[prop.name]
                                    ? prop.labelkey
                                      ? user.data()[prop.name][prop.labelkey]
                                      : user.data()[prop.name]
                                    : "-"}
                                </Typography>
                              );
                            })}
                        </>
                        {/* {JSON.stringify(user.data())} */}
                        {/* <IconButton onClick={() => {
                    setEditing(true)
                  }} color="white" sx={{ bgcolor: 'darkred', borderRadius: 2, m: 2, p: 2 }}>
                    <Iconify icon="bx:edit" />
                    <Typography sx={{ ml: 2}}>แก้ไขข้อมูล</Typography>
                  </IconButton> */}
                      </CardContent>
                      <CardActions>
                        {(toEdit || userInitiated) && (
                          <Button
                            size="large"
                            variant="contained"
                            color="warning"
                            onClick={() => {
                              setEditing(true);
                            }}
                          >
                            แก้ไขข้อมูล
                          </Button>
                        )}

                        {user.exists() && user.data().type && toEdit ? (
                          <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                              if (liff.isInClient()) {
                                liff
                                  .sendMessages([
                                    {
                                      type: "text",
                                      text: "เช็ครอบจอง",
                                    },
                                  ])
                                  .then(liff.closeWindow())
                                  .catch((error) => {
                                    window.alert(`เกิดข้อผิดพลาด: ${error}`);
                                  });
                              } else {
                                liff.logout();
                              }
                            }}
                          >
                            เช็ครอบจอง
                            {/* {liff.isInClient() ? 'เช็ครอบจอง' : 'ลงทะเบียนคนต่อไป'} */}
                          </Button>
                        ) : (
                          <></>
                        )}

                        {user.exists() && user.data().type && toEdit ? (
                          <Button
                            size="large"
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              if (liff.isInClient()) {
                                liff
                                  .sendMessages([
                                    {
                                      type: "text",
                                      text: "เริ่มต้นการเช็คอิน",
                                    },
                                  ])
                                  .then(liff.closeWindow())
                                  .catch((error) => {
                                    window.alert(`เกิดข้อผิดพลาด: ${error}`);
                                  });
                              } else {
                                liff.logout();
                              }
                            }}
                          >
                            เริ่มต้นการเช็คอิน
                            {/* {liff.isInClient() ? 'เริ่มต้นการเช็คอิน' : 'ลงทะเบียนคนต่อไป'} */}
                          </Button>
                        ) : (
                          <></>
                        )}
                      </CardActions>
                    </Card>
                  </Box>
                ))()
              : "ไม่พบผู้ใช้"}
          </div>
        );}
    return (<div>
        <Skeleton variant="rectangular" width={'100%'} height={118} />
        <Box sx={{ pt: 0.5 }}>
              <Skeleton />
              <Skeleton width="60%" />
        </Box>
    </div>)
}